/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Revoke_ErrorInputs */

const vi_api_keys_revoke_error = /** @type {(inputs: Api_Keys_Revoke_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thu hồi được khóa`)
};

/**

* @param {Api_Keys_Revoke_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_revoke_error = /** @type {((inputs?: Api_Keys_Revoke_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Revoke_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_revoke_error(inputs)
});